import { StyleSheet } from 'react-native';
import { neutrals } from 'src/theme/colors';

export const style = StyleSheet.create({
  container: {
    paddingHorizontal: 6,
    paddingTop: 6,
    paddingBottom: 50,
    gap: 24,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    fontSize: 20,
    lineHeight: 26,
    fontWeight: 700,
    color: neutrals.neutralGrays.graphite,
  },
  text: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 24,
    color: neutrals.neutralGrays.graphite,
  },
});
